export const Breadcrumb = {
  parts: ['link', 'item', 'separator'],
  baseStyle: {
    item: {
      color: 'alpha.700',
    },
    link: {
      color: 'alpha.700',
      textAlign: 'center',
      fontSize: '2xs',
      display: 'inline-block',
      fontWeight: 'bold',
      textTransform: 'uppercase',
      textDecoration: 'none',
      _last: { textDecoration: 'underline' },
      '&:hover': { textDecoration: 'none' },
    },
    separator: {
      color: 'alpha.700',
      mx: '2.5',
    },
  },
  sizes: {},
  variants: {},
  defaultProps: {},
};
